import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getCountries = () => ({ type: "GET_COUNTRIES" })
export const getCountriesRequest = () => ({ type: "GET_COUNTRIES_REQUEST" })
export const getCountriesSuccess = payload => ({ type: "GET_COUNTRIES_SUCCESS", payload })
export const getCountriesFailed = error => ({ type: "GET_COUNTRIES_FAILED", error })

export function* getCountriesSaga() {
    yield put(getCountriesRequest())
    try {
        let { data: payload } = yield call(axios,"/countries")
        yield put(getCountriesSuccess(payload))
    } catch(err){
        yield put(getCountriesFailed(err))
    }
}

export default function* countriesSagaWatcher() {
    yield takeEvery("GET_COUNTRIES", getCountriesSaga)
}